export function shifts(state = [], action) {
  switch (action.type) {
    case "SHIFTS_FETCH_DATA_SUCCESS":
      return action.shifts;
    default:
      return state;
  }
}
